import { TbUserStar } from "react-icons/tb";
import styles from "./Utilities.module.scss";

class Utilities {
  static MANUAL = "manual";
  static INCLUDED = "included";

  static isServiceSelected = (item, selectedServices) => {
    if (selectedServices) {
      /**
       * reducer function for array element.
       * method returns a single value: the function's accumulated result
       * method does not execute the function for empty array elements
       * method does not change the original array.
       *
       * At the first callback, there is no return value from the previous callback.
       * Normally, array element 0 is used as initial value, and the iteration starts from array element 1.
       * If an initial value is supplied, this is used, and the iteration starts from array element 0.
       */
      const ids = selectedServices.reduce((prev, curr) => {
        if (prev) prev.push(curr.id_service);
        return prev;
      }, []);
      if (ids) {
        return (
          ids.includes(item.id_service) ||
          ids.includes(item.id_service.toString())
        );
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  static getItemFromSelectedServices = (item, selectedServices) => {
    let retval;
    selectedServices.forEach((element) => {
      if (element.id_service === item.id_service) {
        retval = element;
      }
    });
    return retval;
  };

  static getServiceLowerPrice(service) {
    const MAX_PRICE = 9999999;
    let lowerPrice = MAX_PRICE;
    try {
      service?.staff.forEach((element) => {
        let price = parseInt(element.standard_sell_price);
        if (price === 0) {
          price = parseInt(service.standard_sell_price);
        }
        //Comment
        if (price < lowerPrice) {
          lowerPrice = price;
        }
      });
    } catch (error) {
      console.error(error);
    }
    if (lowerPrice === MAX_PRICE) {
      lowerPrice = 0;
    }
    return lowerPrice;
  }

  static getServiceDependencies(services, service) {
    if (!service) return [];
    if (service.dependencies) {
      const deps = [];
      service.dependencies.forEach((item) => {
        deps.push(this.getServiceById(services, item));
      });

      return deps;
    } else {
      return [];
    }
  }

  static getServiceById(services, id_service) {
    const service = services.find(
      (element) => element.id_service === id_service
    );
    return service;
  }

  static getEmptyEmployee = (service) => {
    const defaultItem = {
      id_employee: "",
      iconJsx: (
        <TbUserStar
          size="10"
          color="#fff"
          className={styles["tb-user-star"]}
          style={{
            width: "25px",
            height: "25px",
            marginRight: "5px",
            borderRadius: "50%",
            padding: "5px",
            minWidth: "25px",
          }}
          alt=""
        />
      ),
      label: "Il primo disponibile",
      label2:
        "da " +
        Utilities.getServiceLowerPrice(service)
          .toFixed(2)
          .toString()
          .replace(".", ",") +
        " €",
    };
    return defaultItem;
  };

  static getEmployeeById = (employees, id_employee) => {
    let employee;
    if (id_employee === "") {
      employee = {
        id_employee: "",
        customer_duration: 0,
        employee_name: "Il primo disponibile",
        iconJsx: (
          <TbUserStar
            size="10"
            color="#fff"
            className={styles["tb-user-star"]}
            style={{
              width: "25px",
              height: "25px",
              marginRight: "5px",
              borderRadius: "50%",
              padding: "5px",
              minWidth: "25px",
            }}
            alt=""
          />
        ),
        description: "",
      };
    } else {
      // eslint-disable-next-line
      employee = employees.find(
        (element) => element.id_employee == id_employee
      );
    }
    return employee;
  };

  static getEndTime = (selectedServices, selectedTime) => {
    if (selectedTime !== undefined) return selectedTime?.time;
  };

  static getSelectedServicePrice(selectedService, services) {
    const service = this.getServiceById(services, selectedService.id_service);
    let price = service?.standard_sell_price;
    if (selectedService.idStaffItem) {
      // eslint-disable-next-line
      const found = service?.staff.find(
        (item) => item.id_employee == selectedService.idStaffItem
      );
      if (found && found.standard_sell_price > 0) {
        price = found.standard_sell_price;
      }
    }
    return parseInt(price);
  }

  static getTotal = (selectedServices, services) => {
    const total = selectedServices.reduce(
      (tot, selectedService, index, array) => {
        const servicePrice = this.getSelectedServicePrice(
          selectedService,
          services
        );
        tot += servicePrice;
        return tot;
      },
      0
    );

    return total;
  };

  static getSelectedServicesForApi = (services, selectedServices) => {
    console.log("Selected Services", selectedServices);
    if (selectedServices) {
      const output = selectedServices.reduce((prev, curr, index, array) => {
        if (prev) {
          prev += ",";
        }
        prev += curr.id_service;
        prev += "_";
        if (curr.idStaffItem) {
          /*
          const service = this.getServiceById(services, curr.id_service);
          const staffIndex = parseInt(curr.idStaffItem);
          const id__employee = service.staff[staffIndex].id_employee;
          */
          prev += curr.idStaffItem;
        } else {
          prev += "-1";
        }

        return prev;
      }, "");
      return output;
    } else {
      return "";
    }
  };
}

export default Utilities;
